import React from 'react'
import HealthcareBanner from '../Healthcare/HealthcareBanner';
import HealthcareExcellence from '../Healthcare/HealthcareExcellence';
import HealthcareFacility from '../Healthcare/HealthcareFacility';
import HealthcareCounter from '../Healthcare/HealthcareCounter';
import HealthcareSmart from '../Healthcare/HealthcareSmart';
import HealthcarePremise from '../Healthcare/HealthcarePremise';
import HealthcareBrand from '../Healthcare/HealthcareBrand';
import HealthcareBusinesse from '../Healthcare/HealthcareBusinesse';
import HealthcareFaq from '../Healthcare/HealthcareFaq';
import HomeProducts from '../../home/HomeProducts';

export default function Landromart({initialData}) {

    const bannerData = {
        head: "Home",
        breadcrumb: [
            {
                slug: "/industrial-laundromat-washing-machines",
                name: "Landromart"
            }
        ]

    }



    const Banner = {
        buttonText: "Global Markets",
        buttonLink: "/markets",
        title: "Equipment That Pays for Itself",
        description: "Commercial laundry machines built for self-service profitability with fast cycles, low maintenance, customer-friendly design, and energy efficiency that turns daily traffic into consistent revenue growth. Every wash generates revenue. Built to maximize your margins.",
        image: "/assets/images/laundromats-banner1.webp"
    };
    const excellenceData = {
        subtitle: "Self-Service Business Specialists",
        title: "More Customers. Faster Turns. Higher Margins.",
        description1: "Your laundromat competes on three things: machine availability, cycle speed, and cleaning quality. Customers won't return if machines break down constantly. They won't wait 90 minutes per load. And they definitely won't pay premium prices for mediocre results.",
        description2: "Supershine builds equipment for laundromat economics. Fast 28-minute cycles mean more customers per day. Reliable construction means fewer out of order signs. Modern design means you can charge more per load. We've equipped 300+ laundromats because we understand the self-service business model.",
        buttonText: "Talk to Our Experts",
        buttonLink: "/contact"
    };

    const facilityData = {
        title: "Built for Self-Service Profitability",
        items: [
            {
                icon: "/assets/images/laundromats-icon1.webp",
                heading: "Customer-Proof Operation",
                description: "Simplified controls and foolproof design handle untrained users without constant jams, errors, or calls for assistance disrupting operations."
            },
            {
                icon: "/assets/images/laundromats-icon2.webp",
                heading: "Revenue Per Machine",
                description: "28-35 minute cycles process more customers hourly, directly increasing daily earnings per machine. More washes. More revenue."
            },
            {
                icon: "/assets/images/laundromats-icon3.webp",
                heading: "Utility Bill Control",
                description: "Efficient water heating and optimized consumption cuts monthly utility expenses 35% compared to older equipment draining profit margins."
            },

            {
                icon: "/assets/images/laundromats-icon4.webp",
                heading: "Curb Appeal Design",
                description: "Clean modern aesthetics, digital displays, and premium finish attract higher-income customers willing to pay more per load regularly."
            },

            {
                icon: "/assets/images/laundromats-icon5.webp",
                heading: "Built to Last",
                description: "Commercial-grade construction delivers 12-15 year lifespan under constant public use versus residential-grade machines failing within 3-5 years."
            },


            {
                icon: "/assets/images/laundromats-icon6.webp",
                heading: "Size Mix Flexibility",
                description: "Multiple capacity options let you serve solo customers, families, and bulk commercial clients from single location maximizing revenue diversity."
            }
        ]
    };


    const HeathCareCounter = {
        title: "Real Laundromat Results",
        stats: [
            {
                end: 300,
                suffix: "+",
                text: "Laundromats Choose <br> Supershine",
            },
            {
                end: 98,
                suffix: "%",
                text: " Customer Return  <br>  Rates",
            },
            {
                end: 1500,
                suffix: "+",
                text: " Daily Loads  <br>  Processed",
            },
            {
                prefix: "",
                end: 35,
                suffix: "%",
                text: "Utility Cost  <br>  Reduction",
            },
        ],
    };

    const Fashionsmart = {
        extraClass: "",
        heading: `Your Competition Has Older, Slower Machines`,
        description: "Most laundromats run 15-year-old equipment with 60+ minute cycles and frequent breakdowns. Modern Supershine machines complete loads in 28-35 minutes, rarely break down, and cost less to operate. That's your competitive advantage.",
        buttonText: "Learn More",
        buttonLink: "/about",
        altText: "Smart"
    };


    const PremiseData = {
        image: "/assets/images/laundromats-left-image.webp",
        title: "What Drives Laundromat Profitability",
        subtitle: "The Business Advantage:",
        reasons: [
            "Increase revenue directly through faster cycle times allowing 40-50% more customer throughput per machine daily versus slow competitor equipment.",
            "Build customer loyalty through consistently excellent cleaning results, reliable machine availability, and modern user experience driving repeat visits weekly.",
            "Slash utility expenses permanently with water recycling systems, efficient heating, optimized consumption cutting monthly bills 35% without reducing service quality.",
            "Attract premium customers through sleek modern design, digital payment options, large capacity choices, and upscale appearance justifying higher per-load pricing.",
            "Avoid revenue loss from commercial construction reducing breakdown frequency 80% versus cheaper equipment constantly displaying out-of-order signs losing sales."
        ],
        buttonText: "Start Your Laundromat Success",
        buttonLink: "/contact"
    };


    const healthcareBrandData = {
        title: "",
        logos: [
            { image: "/assets/images/institute-brand-logo1.webp", title: "Brand 1" },
            { image: "/assets/images/institute-brand-logo2.webp", title: "Brand 2" },
            { image: "/assets/images/institute-brand-logo3.webp", title: "Brand 3" },
            { image: "/assets/images/institute-brand-logo4.webp", title: "Brand 4" },
            { image: "/assets/images/institute-brand-logo6.webp", title: "Brand 6" },
            { image: "/assets/images/institute-brand-logo7.webp", title: "Brand 2" },
            { image: "/assets/images/institute-brand-logo8.webp", title: "Brand 3" },
            { image: "/assets/images/institute-brand-logo9.webp", title: "Brand 3" },
            { image: "/assets/images/institute-brand-logo10.webp", title: "Brand 3" },
            { image: "/assets/images/institute-brand-logo11.webp", title: "Brand 3" },
        ]
    };




    const businessData = {
        title: "What Laundromat <br/> Owners Are Saying.",
        description:
            "Everyday laundromat operations demand machines that just work. Supershine delivers durability, lower running costs, and dependable everyday performance.",
        testimonials: [
            {
                rating: 5,
                text:
                    "“Running a self-service laundromat means machines need to survive constant use by customers who treat them differently every time. Supershine's machines have held up impressively well over the past year, with far fewer service calls than our old setup. Customers have also commented on faster cycle times, which keeps footfall steady through the day.”",
                client: "Sandeep Malhotra, Owner, Self-Service Laundromat",
            },
            {
                rating: 5,
                text:
                    "“For a small business like ours, every rupee in utility bills matters. Supershine's machines reduced our water and electricity consumption noticeably, even though we're running more loads per day than before. That saving alone has improved our margins, and the equipment hasn't given us a single major issue since installation.”",
                client: "Pooja Iyer, Owner, Neighbourhood Laundromat",
            },
            {
                rating: 5,
                text:
                    "“Customer trust in a laundromat comes down to consistency; the same cycle should give the same result every time. Supershine's equipment has delivered exactly that, and the reduced noise levels have also made the space more comfortable for customers waiting around. It has genuinely changed how our regulars perceive the place.”",
                client: "Ravi Dutta, Owner, Coin Laundry Outlet",
            },
        ],
    };


    const productData = {
        subtitle: "Recommended Products",
        title: "Premium Machines That <br> Keep Customers Coming Back",
    
    };

    const faqData = {
        title: "FAQs",
        description: "Straight answers for laundromat owners and investors making equipment decisions.",
        buttonText: "Talk to an expert",
        buttonLink: "/contact",
        faqs: [
            {
                question: "What's the actual payback period for laundromat equipment?",
                answer:
                    "Most owners achieve 3-4 year payback in moderate traffic locations through increased customer throughput, reduced utility bills, and avoided repair costs. High-traffic urban locations often see 2-3 year payback. Financing typically costs less monthly than the operational savings generated immediately.",
            },
            {
                question: "How do faster cycles actually increase profit?",
                answer:
                    "Simple math: 60-minute cycles allow 10 customers per machine daily. Our 30-minute cycles allow 20 customers daily. That doubles revenue per machine. Even at 50% utilization, you're processing significantly more paying customers per day per square foot of floor space.",
            },
            {
                question: "Can customers really operate commercial machines without help?",
                answer:
                    "Yes. Our interfaces use simple buttons, clear icons, and step-by-step prompts. Customers who can use an ATM can use our machines. Pre-programmed cycles eliminate guesswork. Digital displays show time remaining. Payment systems are intuitive. Minimal intervention needed from staff.",
            },

            {
                question: "What happens when machines break down?",
                answer:
                    "We provide 24/7 technical phone support for troubleshooting, next-day parts delivery in metro areas, and nationwide service network. Most issues resolve remotely. For on-site needs, technicians respond within 24-48 hours. Systems are designed for reliability, with most owners reporting minimal service calls annually.",
            },

            {
                question: "Should I buy or lease laundromat equipment?",
                answer:
                    "Depends on cash flow and tax situation. Purchasing builds equity and costs less long-term. Leasing preserves capital, offers tax benefits, and includes maintenance. Many owners purchase core equipment and lease specialty machines. We connect you with financing partners offering both options competitively.",
            },

            {
                question: "How much space do I need per machine?",
                answer:
                    "Standard front-loaders need 30-36 inches width. Top-loaders need slightly less. Plan 40-45 inches spacing for customer access. A 2,000 sq ft space typically accommodates 15-20 washers and 10-12 dryers comfortably with seating area. We provide free layout planning matching your space.",
            },
        ],
    };

    return (
        <>
            <HealthcareBanner data={Banner} breadcrumb={bannerData.breadcrumb}/>
            <HealthcareExcellence data={excellenceData} />
            <HealthcareFacility data={facilityData} />
            <HealthcareCounter data={HeathCareCounter} />
            <HealthcareSmart data={Fashionsmart} />
            <HealthcarePremise data={PremiseData} />
            <HealthcareBrand data={healthcareBrandData} extraClas="" />
            <HealthcareBusinesse data={businessData} />
            <HomeProducts data={productData} extraClass="healthcare-product"  initialData={initialData}/>
            <HealthcareFaq data={faqData} />
        </>
    )
}









